
import BlogAndArticle from "../Components/FirstComponents/BlogAndArticle";
import Ads from "../Components/FirstComponents/Ads";
import PatientView from "../Components/FirstComponents/PatientsView";
import Banner from "../Utils/Banner";

function Testimonials() {
  return (
    <div className="w-full overflow-x-hidden">
      <div
        className="bg-gray-200 bg-no-repeat bg-contain w-full"
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <div className="mx-auto max-w-7xl w-full overflow-x-hidden">
          <Banner title="Testimonials" imageUrl="/assets/Second_Banner.png" />

          <div className="px-4 sm:px-6 lg:px-8">
            {/* <MythsFacts /> */}
            <PatientView />
            {/* <BlogAndArticle /> */}
            {/* <Ads /> */}
            {/* <Subscribe /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
